import {
  Companion_getInstance2a6946bmnnmyk as Companion_getInstance,
  EventSubscription13rxmq485x98c as EventSubscription,
  NotificationFrequency6nobdojsdzj9 as NotificationFrequency,
  UserEventType3ayinm14vltts as UserEventType,
} from './shared.mjs';
import { NothingSerializer3oixyyf77l4xt as NothingSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { KtSetjrjc7fhfd6b9 as KtSet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function prepareEventSubscriptionFields() {
  var tmp = Companion_getInstance().c8k(NothingSerializer());
  properties(tmp, prepareEventSubscriptionFields$lambda);
}
function EventSubscription_email$name$delegate$lambda() {
  return Companion_getInstance().c8k(NothingSerializer()).az().v11(5);
}
function EventSubscription_email$_get_name_$ref_ftk21t() {
  return (p0) => p0.i20();
}
function EventSubscription_email$_get_serializer_$ref_w3wloo() {
  return (p0) => p0.h2j();
}
function EventSubscription_email$_get_annotations_$ref_h16z3o() {
  return (p0) => p0.bz();
}
var EventSubscription_emailClass;
function EventSubscription_email() {
  if (EventSubscription_emailClass === VOID) {
    class $ {
      constructor(uID) {
        var tmp = this;
        tmp.d8k_1 = lazy(EventSubscription_email$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.e8k_1 = lazy(() => {
          var tmp = Companion_getInstance().c8k(uID);
          var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[5];
          return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
        });
        var tmp_1 = this;
        tmp_1.f8k_1 = lazy(() => Companion_getInstance().c8k(uID).az().x11(5));
      }
      i20() {
        var tmp0 = this.d8k_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, EventSubscription_email$_get_name_$ref_ftk21t(), null);
        return tmp0.f2();
      }
      g8k(receiver) {
        return receiver.m8k_1;
      }
      k2j(receiver) {
        return this.g8k(receiver instanceof EventSubscription() ? receiver : THROW_CCE());
      }
      p8k(receiver, value) {
        return receiver.q8k(VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof EventSubscription() ? receiver : THROW_CCE();
        return this.p8k(tmp, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.e8k_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, EventSubscription_email$_get_serializer_$ref_w3wloo(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.f8k_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, EventSubscription_email$_get_annotations_$ref_h16z3o(), null);
        return tmp0.f2();
      }
      hashCode() {
        return 468349083;
      }
      equals(other) {
        return other instanceof EventSubscription_email();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForClass($, 'EventSubscription_email', VOID, VOID, [SerializableProperty()]);
    EventSubscription_emailClass = $;
  }
  return EventSubscription_emailClass;
}
function EventSubscription_sms$name$delegate$lambda() {
  return Companion_getInstance().c8k(NothingSerializer()).az().v11(7);
}
function EventSubscription_sms$_get_name_$ref_xtn6im() {
  return (p0) => p0.i20();
}
function EventSubscription_sms$_get_serializer_$ref_uh5kez() {
  return (p0) => p0.h2j();
}
function EventSubscription_sms$_get_annotations_$ref_59msp5() {
  return (p0) => p0.bz();
}
var EventSubscription_smsClass;
function EventSubscription_sms() {
  if (EventSubscription_smsClass === VOID) {
    class $ {
      constructor(uID) {
        var tmp = this;
        tmp.r8k_1 = lazy(EventSubscription_sms$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.s8k_1 = lazy(() => {
          var tmp = Companion_getInstance().c8k(uID);
          var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[7];
          return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
        });
        var tmp_1 = this;
        tmp_1.t8k_1 = lazy(() => Companion_getInstance().c8k(uID).az().x11(7));
      }
      i20() {
        var tmp0 = this.r8k_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, EventSubscription_sms$_get_name_$ref_xtn6im(), null);
        return tmp0.f2();
      }
      g8k(receiver) {
        return receiver.o8k_1;
      }
      k2j(receiver) {
        return this.g8k(receiver instanceof EventSubscription() ? receiver : THROW_CCE());
      }
      p8k(receiver, value) {
        return receiver.q8k(VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof EventSubscription() ? receiver : THROW_CCE();
        return this.p8k(tmp, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.s8k_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, EventSubscription_sms$_get_serializer_$ref_uh5kez(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.t8k_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, EventSubscription_sms$_get_annotations_$ref_59msp5(), null);
        return tmp0.f2();
      }
      hashCode() {
        return 1771648638;
      }
      equals(other) {
        return other instanceof EventSubscription_sms();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForClass($, 'EventSubscription_sms', VOID, VOID, [SerializableProperty()]);
    EventSubscription_smsClass = $;
  }
  return EventSubscription_smsClass;
}
function EventSubscription_push$name$delegate$lambda() {
  return Companion_getInstance().c8k(NothingSerializer()).az().v11(6);
}
function EventSubscription_push$_get_name_$ref_fakmnj() {
  return (p0) => p0.i20();
}
function EventSubscription_push$_get_serializer_$ref_52ry52() {
  return (p0) => p0.h2j();
}
function EventSubscription_push$_get_annotations_$ref_vfjcx2() {
  return (p0) => p0.bz();
}
var EventSubscription_pushClass;
function EventSubscription_push() {
  if (EventSubscription_pushClass === VOID) {
    class $ {
      constructor(uID) {
        var tmp = this;
        tmp.u8k_1 = lazy(EventSubscription_push$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.v8k_1 = lazy(() => {
          var tmp = Companion_getInstance().c8k(uID);
          var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[6];
          return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
        });
        var tmp_1 = this;
        tmp_1.w8k_1 = lazy(() => Companion_getInstance().c8k(uID).az().x11(6));
      }
      i20() {
        var tmp0 = this.u8k_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, EventSubscription_push$_get_name_$ref_fakmnj(), null);
        return tmp0.f2();
      }
      g8k(receiver) {
        return receiver.n8k_1;
      }
      k2j(receiver) {
        return this.g8k(receiver instanceof EventSubscription() ? receiver : THROW_CCE());
      }
      p8k(receiver, value) {
        return receiver.q8k(VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof EventSubscription() ? receiver : THROW_CCE();
        return this.p8k(tmp, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.v8k_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, EventSubscription_push$_get_serializer_$ref_52ry52(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.w8k_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, EventSubscription_push$_get_annotations_$ref_vfjcx2(), null);
        return tmp0.f2();
      }
      hashCode() {
        return 1875147997;
      }
      equals(other) {
        return other instanceof EventSubscription_push();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForClass($, 'EventSubscription_push', VOID, VOID, [SerializableProperty()]);
    EventSubscription_pushClass = $;
  }
  return EventSubscription_pushClass;
}
function EventSubscription_frequency$name$delegate$lambda() {
  return Companion_getInstance().c8k(NothingSerializer()).az().v11(4);
}
function EventSubscription_frequency$_get_name_$ref_1exwrl() {
  return (p0) => p0.i20();
}
function EventSubscription_frequency$_get_serializer_$ref_fxtchk() {
  return (p0) => p0.h2j();
}
function EventSubscription_frequency$_get_annotations_$ref_j77p84() {
  return (p0) => p0.bz();
}
var EventSubscription_frequencyClass;
function EventSubscription_frequency() {
  if (EventSubscription_frequencyClass === VOID) {
    class $ {
      constructor(uID) {
        var tmp = this;
        tmp.x8k_1 = lazy(EventSubscription_frequency$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.y8k_1 = lazy(() => {
          var tmp = Companion_getInstance().c8k(uID);
          var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[4];
          return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
        });
        var tmp_1 = this;
        tmp_1.z8k_1 = lazy(() => Companion_getInstance().c8k(uID).az().x11(4));
      }
      i20() {
        var tmp0 = this.x8k_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, EventSubscription_frequency$_get_name_$ref_1exwrl(), null);
        return tmp0.f2();
      }
      g8k(receiver) {
        return receiver.l8k_1;
      }
      k2j(receiver) {
        return this.g8k(receiver instanceof EventSubscription() ? receiver : THROW_CCE());
      }
      a8l(receiver, value) {
        return receiver.q8k(VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof EventSubscription() ? receiver : THROW_CCE();
        return this.a8l(tmp, value instanceof NotificationFrequency() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.y8k_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, EventSubscription_frequency$_get_serializer_$ref_fxtchk(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.z8k_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, EventSubscription_frequency$_get_annotations_$ref_j77p84(), null);
        return tmp0.f2();
      }
      hashCode() {
        return -402624805;
      }
      equals(other) {
        return other instanceof EventSubscription_frequency();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForClass($, 'EventSubscription_frequency', VOID, VOID, [SerializableProperty()]);
    EventSubscription_frequencyClass = $;
  }
  return EventSubscription_frequencyClass;
}
function EventSubscription__id$name$delegate$lambda() {
  return Companion_getInstance().c8k(NothingSerializer()).az().v11(0);
}
function EventSubscription__id$_get_name_$ref_m23qrj() {
  return (p0) => p0.i20();
}
function EventSubscription__id$_get_serializer_$ref_lc29t2() {
  return (p0) => p0.h2j();
}
function EventSubscription__id$_get_annotations_$ref_wth17u() {
  return (p0) => p0.bz();
}
var EventSubscription__idClass;
function EventSubscription__id() {
  if (EventSubscription__idClass === VOID) {
    class $ {
      constructor(uID) {
        var tmp = this;
        tmp.b8l_1 = lazy(EventSubscription__id$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.c8l_1 = lazy(() => {
          var tmp = Companion_getInstance().c8k(uID);
          var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[0];
          return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
        });
        var tmp_1 = this;
        tmp_1.d8l_1 = lazy(() => Companion_getInstance().c8k(uID).az().x11(0));
      }
      i20() {
        var tmp0 = this.b8l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, EventSubscription__id$_get_name_$ref_m23qrj(), null);
        return tmp0.f2();
      }
      g8k(receiver) {
        return receiver.h8k_1;
      }
      k2j(receiver) {
        return this.g8k(receiver instanceof EventSubscription() ? receiver : THROW_CCE());
      }
      e8l(receiver, value) {
        return receiver.q8k(value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof EventSubscription() ? receiver : THROW_CCE();
        return this.e8l(tmp, value instanceof UserEventType() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.c8l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, EventSubscription__id$_get_serializer_$ref_lc29t2(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.d8l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, EventSubscription__id$_get_annotations_$ref_wth17u(), null);
        return tmp0.f2();
      }
      hashCode() {
        return 1771048509;
      }
      equals(other) {
        return other instanceof EventSubscription__id();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForClass($, 'EventSubscription__id', VOID, VOID, [SerializableProperty()]);
    EventSubscription__idClass = $;
  }
  return EventSubscription__idClass;
}
function EventSubscription_requestedFilter$name$delegate$lambda() {
  return Companion_getInstance().c8k(NothingSerializer()).az().v11(1);
}
function EventSubscription_requestedFilter$_get_name_$ref_8etpjf() {
  return (p0) => p0.i20();
}
function EventSubscription_requestedFilter$_get_serializer_$ref_59wvoy() {
  return (p0) => p0.h2j();
}
function EventSubscription_requestedFilter$_get_annotations_$ref_xgbsxi() {
  return (p0) => p0.bz();
}
var EventSubscription_requestedFilterClass;
function EventSubscription_requestedFilter() {
  if (EventSubscription_requestedFilterClass === VOID) {
    class $ {
      constructor(uID) {
        var tmp = this;
        tmp.f8l_1 = lazy(EventSubscription_requestedFilter$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.g8l_1 = lazy(() => {
          var tmp = Companion_getInstance().c8k(uID);
          var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[1];
          return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
        });
        var tmp_1 = this;
        tmp_1.h8l_1 = lazy(() => Companion_getInstance().c8k(uID).az().x11(1));
      }
      i20() {
        var tmp0 = this.f8l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, EventSubscription_requestedFilter$_get_name_$ref_8etpjf(), null);
        return tmp0.f2();
      }
      g8k(receiver) {
        return receiver.i8k_1;
      }
      k2j(receiver) {
        return this.g8k(receiver instanceof EventSubscription() ? receiver : THROW_CCE());
      }
      i8l(receiver, value) {
        return receiver.q8k(VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof EventSubscription() ? receiver : THROW_CCE();
        return this.i8l(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.g8l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, EventSubscription_requestedFilter$_get_serializer_$ref_59wvoy(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.h8l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, EventSubscription_requestedFilter$_get_annotations_$ref_xgbsxi(), null);
        return tmp0.f2();
      }
      hashCode() {
        return -452373263;
      }
      equals(other) {
        return other instanceof EventSubscription_requestedFilter();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForClass($, 'EventSubscription_requestedFilter', VOID, VOID, [SerializableProperty()]);
    EventSubscription_requestedFilterClass = $;
  }
  return EventSubscription_requestedFilterClass;
}
function EventSubscription_readPermissions$name$delegate$lambda() {
  return Companion_getInstance().c8k(NothingSerializer()).az().v11(2);
}
function EventSubscription_readPermissions$_get_name_$ref_ox784t() {
  return (p0) => p0.i20();
}
function EventSubscription_readPermissions$_get_serializer_$ref_gjlafa() {
  return (p0) => p0.h2j();
}
function EventSubscription_readPermissions$_get_annotations_$ref_g5h6q() {
  return (p0) => p0.bz();
}
var EventSubscription_readPermissionsClass;
function EventSubscription_readPermissions() {
  if (EventSubscription_readPermissionsClass === VOID) {
    class $ {
      constructor(uID) {
        var tmp = this;
        tmp.j8l_1 = lazy(EventSubscription_readPermissions$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.k8l_1 = lazy(() => {
          var tmp = Companion_getInstance().c8k(uID);
          var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[2];
          return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
        });
        var tmp_1 = this;
        tmp_1.l8l_1 = lazy(() => Companion_getInstance().c8k(uID).az().x11(2));
      }
      i20() {
        var tmp0 = this.j8l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, EventSubscription_readPermissions$_get_name_$ref_ox784t(), null);
        return tmp0.f2();
      }
      g8k(receiver) {
        return receiver.j8k_1;
      }
      k2j(receiver) {
        return this.g8k(receiver instanceof EventSubscription() ? receiver : THROW_CCE());
      }
      i8l(receiver, value) {
        return receiver.q8k(VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof EventSubscription() ? receiver : THROW_CCE();
        return this.i8l(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.k8l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, EventSubscription_readPermissions$_get_serializer_$ref_gjlafa(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.l8l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, EventSubscription_readPermissions$_get_annotations_$ref_g5h6q(), null);
        return tmp0.f2();
      }
      hashCode() {
        return 1220010345;
      }
      equals(other) {
        return other instanceof EventSubscription_readPermissions();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForClass($, 'EventSubscription_readPermissions', VOID, VOID, [SerializableProperty()]);
    EventSubscription_readPermissionsClass = $;
  }
  return EventSubscription_readPermissionsClass;
}
function EventSubscription_filterHashes$name$delegate$lambda() {
  return Companion_getInstance().c8k(NothingSerializer()).az().v11(3);
}
function EventSubscription_filterHashes$_get_name_$ref_oea1xz() {
  return (p0) => p0.i20();
}
function EventSubscription_filterHashes$_get_serializer_$ref_j0dqls() {
  return (p0) => p0.h2j();
}
function EventSubscription_filterHashes$_get_annotations_$ref_4z8efo() {
  return (p0) => p0.bz();
}
var EventSubscription_filterHashesClass;
function EventSubscription_filterHashes() {
  if (EventSubscription_filterHashesClass === VOID) {
    class $ {
      constructor(uID) {
        var tmp = this;
        tmp.m8l_1 = lazy(EventSubscription_filterHashes$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.n8l_1 = lazy(() => {
          var tmp = Companion_getInstance().c8k(uID);
          var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[3];
          return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
        });
        var tmp_1 = this;
        tmp_1.o8l_1 = lazy(() => Companion_getInstance().c8k(uID).az().x11(3));
      }
      i20() {
        var tmp0 = this.m8l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, EventSubscription_filterHashes$_get_name_$ref_oea1xz(), null);
        return tmp0.f2();
      }
      g8k(receiver) {
        return receiver.k8k_1;
      }
      k2j(receiver) {
        return this.g8k(receiver instanceof EventSubscription() ? receiver : THROW_CCE());
      }
      p8l(receiver, value) {
        return receiver.q8k(VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof EventSubscription() ? receiver : THROW_CCE();
        return this.p8l(tmp, (!(value == null) ? isInterface(value, KtSet()) : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.n8l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, EventSubscription_filterHashes$_get_serializer_$ref_j0dqls(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.o8l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, EventSubscription_filterHashes$_get_annotations_$ref_4z8efo(), null);
        return tmp0.f2();
      }
      hashCode() {
        return 1766409059;
      }
      equals(other) {
        return other instanceof EventSubscription_filterHashes();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForClass($, 'EventSubscription_filterHashes', VOID, VOID, [SerializableProperty()]);
    EventSubscription_filterHashesClass = $;
  }
  return EventSubscription_filterHashesClass;
}
function prepareEventSubscriptionFields$lambda(args) {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [new (EventSubscription__id())(args[0]), new (EventSubscription_requestedFilter())(args[0]), new (EventSubscription_readPermissions())(args[0]), new (EventSubscription_filterHashes())(args[0]), new (EventSubscription_frequency())(args[0]), new (EventSubscription_email())(args[0]), new (EventSubscription_push())(args[0]), new (EventSubscription_sms())(args[0])];
}
//region block: exports
export {
  EventSubscription__id as EventSubscription__id1u3p9t167zyq1,
  EventSubscription_email as EventSubscription_email3bp1h34w94knn,
  EventSubscription_frequency as EventSubscription_frequencyf8n11hvgmqn1,
  EventSubscription_push as EventSubscription_push36iueneirbwc,
  EventSubscription_sms as EventSubscription_sms1dq2yae9wjcc7,
  prepareEventSubscriptionFields as prepareEventSubscriptionFields3trb33um5wei2,
};
//endregion

//# sourceMappingURL=EventSubscriptionFields.mjs.map
